export var RSVP = {
    ACCEPTED: 'accepted',
    DECLINED: 'declined',
    TENTATIVE: 'tentative',
    NOT_RESPONDED: 'not_responded',
    UNKNOWN: 'unknown',
    DELEGATED: 'delegated',
};
export var SELECTABLE_RSVP_STATUSES = [
    RSVP.ACCEPTED,
    RSVP.DECLINED,
    RSVP.TENTATIVE,
];
export function isPersonInvitee(invitee) {
    return invitee.space_id == null && !invitee.is_resource;
}
export function getCurrentUserInvitee(event, currentUser) {
    var _a, _b, _c;
    var email = (_b = (_a = currentUser.primaryEmail) === null || _a === void 0 ? void 0 : _a.email) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    if (!email && !currentUser.id)
        return undefined;
    var userId = Number(currentUser.id);
    return (_c = event.invitees) === null || _c === void 0 ? void 0 : _c.filter(isPersonInvitee).find(function (invitee) {
        var _a;
        return (userId && invitee.user_id === userId) ||
            (!!email && ((_a = invitee.email) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === email);
    });
}
export function normalizeRsvpStatus(responseStatus) {
    if (!responseStatus || responseStatus === RSVP.UNKNOWN) {
        return RSVP.NOT_RESPONDED;
    }
    if (responseStatus === RSVP.DELEGATED) {
        return RSVP.ACCEPTED;
    }
    if (SELECTABLE_RSVP_STATUSES.includes(responseStatus)) {
        return responseStatus;
    }
    return RSVP.NOT_RESPONDED;
}
export function calendarMatchesEventRemoteType(calendarRemoteType, eventRemoteType) {
    if (eventRemoteType === 'google') {
        return calendarRemoteType === 'google';
    }
    if (eventRemoteType === 'microsoft_ews') {
        return calendarRemoteType === 'microsoft_ews';
    }
    if (eventRemoteType.startsWith('microsoft')) {
        return calendarRemoteType.startsWith('microsoft');
    }
    return calendarRemoteType === eventRemoteType;
}
export function hasWritableCalendarForEvent(eventRemoteType, calendars) {
    if (!eventRemoteType) {
        return false;
    }
    return calendars.some(function (calendar) {
        return calendarMatchesEventRemoteType(calendar.remote_type, eventRemoteType);
    });
}
/**
 * Outlook has no organizer RSVP — on a Microsoft-calendared event the
 * organizer is implicitly accepted, so once the reservation is approved
 * offering RSVP to the organizer is a dead end. Google lets organizers
 * RSVP their own events, so those keep the actions. `microsoft` prefix
 * covers microsoft_365 and microsoft_ews (same Outlook semantics).
 */
export function shouldHideOrganizerRsvp(event, invitee) {
    var _a, _b;
    return (!!(invitee === null || invitee === void 0 ? void 0 : invitee.is_organizer) &&
        !!((_a = event.remote_type) === null || _a === void 0 ? void 0 : _a.startsWith('microsoft')) &&
        ((_b = event.reservation_approval) === null || _b === void 0 ? void 0 : _b.approved) === true);
}
export function canShowRsvpActions(event, currentUser, calendars) {
    var currentUserInvitee = getCurrentUserInvitee(event, currentUser);
    if (!currentUserInvitee) {
        return false;
    }
    if (shouldHideOrganizerRsvp(event, currentUserInvitee)) {
        return false;
    }
    return hasWritableCalendarForEvent(event.remote_type, calendars);
}
